export const YANDEX_VIDEO_ITEM_CONSTS = {
    deleteMsg: 'Удалить',
    deleteQuestionMsg: 'Вы уверены, что хотите удалить видео?',
    editMsg: 'Изменить',
    warningMsg: 'Внимание!'
}
